export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10227.59612cf3.jpg";